/**
 * Push Notification Service - API client for Web Push subscriptions and
 * per-user notification preferences (backend routes under /api/push/...).
 */
import api from '../utils/api';

const pushNotificationService = {
  getVapidPublicKey: async () => {
    try {
      return await api.get('/api/push/vapid-public-key');
    } catch (error) {
      console.error('Error fetching VAPID public key:', error);
      throw error;
    }
  },

  subscribe: async (data) => {
    try {
      return await api.post('/api/push/subscribe', data);
    } catch (error) {
      console.error('Error subscribing to push notifications:', error);
      throw error;
    }
  },

  unsubscribe: async (endpoint) => {
    try {
      return await api.post('/api/push/unsubscribe', { endpoint });
    } catch (error) {
      console.error('Error unsubscribing from push notifications:', error);
      throw error;
    }
  },

  getMySubscriptions: async () => {
    try {
      return await api.get('/api/push/subscriptions/mine');
    } catch (error) {
      console.error('Error fetching my push subscriptions:', error);
      throw error;
    }
  },

  sendTestPush: async () => {
    try {
      return await api.post('/api/push/test', {});
    } catch (error) {
      console.error('Error sending test push notification:', error);
      throw error;
    }
  },

  getMyPreferences: async () => {
    try {
      return await api.get('/api/push/preferences/me');
    } catch (error) {
      console.error('Error fetching my notification preferences:', error);
      throw error;
    }
  },

  updateMyPreferences: async (data) => {
    try {
      return await api.put('/api/push/preferences/me', data);
    } catch (error) {
      console.error('Error updating my notification preferences:', error);
      throw error;
    }
  },
};

export default pushNotificationService;
